import axios from './axios';

export function getPhoneCode(data) {
  return axios.post('/api/v1/web/register/mobile/reset_phone_code', data, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function updatePhoneNumber(options) {
  return axios.post('/api/v1/web/auth/reset_phone', options, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function updateUserEmail(options) {
  return axios.post('/api/v1/web/auth/reset_email', options, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function updateUserPwd(options) {
  return axios.post('/api/v1/web/auth/reset_password', options, {
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function closeWechatApi(options) {
  return axios.get('/api/v1/web/register/wechat/close_bind', {
    params: {}
  }, {
    headers: {
      "Authorization": options.token
    }
  });
}